import { jwtDecode } from 'jwt-decode';

/** Утверждения access-токена, которые читает клиент; подпись не проверяется — это делает сервер. */
export interface AuthJwtClaims {
    exp?: number;
    /** 'SAML' — выход через IdP */
    signInMethod?: string;
    [claim: string]: unknown;
}

/** Утверждения JWT или null, если токен не разбирается. */
export const decodeJwtClaims = (accessToken: string): AuthJwtClaims | null => {
    try {
        return jwtDecode<AuthJwtClaims>(accessToken);
    } catch {
        return null;
    }
};

/** Время истечения JWT в миллисекундах epoch или null, если токен не разбирается или `exp` нет. */
export const decodeExpMs = (accessToken: string): number | null => {
    const exp = decodeJwtClaims(accessToken)?.exp;
    return typeof exp === 'number' && exp ? exp * 1000 : null;
};

/** Способ входа (`signInMethod`) или undefined — битый токен не мешает обычному выходу. */
export const decodeSignInMethod = (accessToken: string): string | undefined => {
    const method = decodeJwtClaims(accessToken)?.signInMethod;
    return typeof method === 'string' ? method : undefined;
};

/**
 * Claim пользователя: сервер пишет `ClaimTypes.NameIdentifier` через `new JwtSecurityToken(...)` — тип claim как есть
 * (URI), без короткого `nameid` (`WebAPI.Auth/Services/Tokens/TokenService.cs`). `nameid`/`sub` — если выдачу когда-
 * нибудь переведут на `JwtSecurityTokenHandler.CreateToken` с картой коротких имён.
 */
const USER_ID_CLAIMS = ['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier', 'nameid', 'sub'];

/** Идентификатор пользователя access-токена или undefined — токен не разбирается или claim нет. */
export const decodeUserId = (accessToken: string): string | undefined => {
    const claims = decodeJwtClaims(accessToken);
    for (const name of USER_ID_CLAIMS) {
        const value = claims?.[name];
        if (typeof value === 'string' && value) return value;
        if (typeof value === 'number') return String(value);
    }
    return undefined;
};
